import { useFormContext } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface Props {
    className?: string;
    name: string;
    label?: string;
    placeholder?: string;
    options?: { name: string; value: string }[];
    error?: string | null;
    disabled?: boolean;
    onChange?: (value: string) => void; // تعديل نوع onChange
    selectContentClassName?: string; // className للـ SelectContent
}

export default function SelectInputForm({
    className,
    name,
    label,
    options,
    placeholder,
    error,
    disabled,
    onChange,
    selectContentClassName,
}: Props) {
    const { control } = useFormContext();

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <FormLabel className="text-primery-blue-900 font-medium md:text-[18px] text-[16px] leading-[33.73px] tracking-normal text-start">
                        {label}
                    </FormLabel>
                    <Select
                        onValueChange={(value) => {
                            field.onChange(value); // تحديث قيمة الحقل في react-hook-form
                            if (onChange) onChange(value); // استدعاء onChange الممرر
                        }}
                        value={field.value}
                        defaultValue=""
                        disabled={disabled}
                    >
                        <FormControl>
                            <SelectTrigger>
                                <SelectValue placeholder={<span style={{ color: '#D1D1D1' }}>{placeholder}</span>} />
                            </SelectTrigger>
                        </FormControl>
                        <SelectContent className={selectContentClassName}>
                            {options?.map(({ name, value }) => (
                                <SelectItem key={value} value={value} className="font-cairo">
                                    {name}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                    <FormMessage>{error}</FormMessage>
                </FormItem>
            )}
        />
    );
}
